import WireWidgetCard, { StatusPill } from "./WireWidgetCard";
import { formatWireAmount, getWireAmount } from "../wireUtils";

/**
 * Deposit confirmation. A pending confirmation never blocks another, so the
 * action is always available ("Confirm deposit" / "Confirm one more").
 */
const DepositConfirmationWidget = ({ pendingDeposits = [], onConfirm }) => {
  const count = pendingDeposits.length;
  const total = pendingDeposits.reduce((sum, w) => sum + (getWireAmount(w) || 0), 0);

  let body;
  if (count === 0) {
    body = (
      <div className="widget-muted">
        Confirm a wire you have sent and attach a receipt. Support will match it to your deposit.
      </div>
    );
  } else if (count === 1) {
    body = (
      <>
        <div className="widget-line">
          <span className="widget-label">Wire confirmation</span>
        </div>
        <div className="widget-amount">
          {formatWireAmount(getWireAmount(pendingDeposits[0]))}
          <StatusPill progress="pending" />
        </div>
        <div className="widget-muted">You can confirm another wire transfer.</div>
      </>
    );
  } else {
    body = (
      <>
        <div className="widget-line">
          <span className="widget-label">{count} pending confirmations</span>
        </div>
        <div className="widget-amount">
          {formatWireAmount(total)}
          <span className="widget-amount-sub">total</span>
        </div>
      </>
    );
  }

  const label = count === 0 ? "Confirm deposit" : "Confirm one more";

  return (
    <WireWidgetCard
      title="Deposit confirmation"
      actions={[{ id: "deposit-confirmation-btn", label, onClick: onConfirm }]}
    >
      {body}
    </WireWidgetCard>
  );
};

export default DepositConfirmationWidget;
